var _a;
const $apptBtn = document.getElementById("store-appt-btn");
const $appt = document.getElementById("store-appt-panel");
const apiKey = ((_a = _JK == null ? void 0 : _JK.config) == null ? void 0 : _a.tulip_api_key) || "";
let initStoreApptsComplete = false;
if ($apptBtn && $appt && apiKey) {
  let makeAppt = function() {
    const tps = timekit_project_selector;
    if (!initStoreApptsComplete) {
      tps.init({
        app_key: apiKey,
        defaultUI: true,
        embed: true,
        includePrivateAppointments: true,
        selectorOptions: {
          store_project: {
            title: "Select a Store",
            description: "Select a store from the following that you will be visiting for your appointment.",
            card_title: "[meta]t_store_name",
            card_body: "{{[meta]t_store_address}}, {{[meta]t_store_city}}",
            card_footer: "[meta]t_store_phone",
            strategy: "store_project"
          },
          service_project: {
            title: "Select an Appointment Type",
            description: "Which appointment type would you like?",
            card_image: "{{[project]image_url}}",
            card_title: "{{[project]name}}",
            card_body: "{{[project] description}}",
            card_footer: "<i class='far fa-clock'></i> {{[project]availability.length}}",
            filters: {
              t_disabled: 0
            }
          }
        }
      }).then(() => {
        const isVisible = !$appt.classList.contains("invisible");
        if (isVisible) {
          $appt.classList.add("opacity-0");
          setTimeout(() => $appt.classList.add("invisible"), 300);
        } else {
          $appt.classList.remove("invisible");
          requestAnimationFrame(() => {
            $appt.classList.remove("opacity-0");
          });
        }
        $apptBtn.disabled = true;
        $apptBtn.classList.remove("cursor-pointer");
        $apptBtn.setAttribute("aria-expanded", "true");
        initStoreApptsComplete = true;
      }).catch((error) => {
        console.log("ERR: Could not load Tulip appt app");
        console.log(error);
      });
    }
  };
  var makeAppt2 = makeAppt;
  $apptBtn.addEventListener("click", () => {
    makeAppt();
  });
}
